module.exports = __webpack_public_path__ + "static/media/injuredCalm.626ba111.mp3";